'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiKey = function TiKey(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.2 18.3c0 1.3 0.2 2.4 0.7 3.5l-6.6 6.5v2.5s1.5 2.5 3.4 2.5h3.3v-3.3h3.3v-3.3h4.2c4.6 0 8.3-3.8 8.3-8.4s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3z m8.3 3.4c-1.8 0-3.3-1.5-3.3-3.4 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.9-1.5 3.4-3.3 3.4z' })
        )
    );
};

exports.default = TiKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/key.js
// module id = 3635
// module chunks = 0